import * as wConst from '../consts/website-consts';
import * as wActs from "./website-actions";
import {fetch, addTask} from "domain-task";
import {defaultLang} from "./website-actions";
import {getCultByLang} from "./website-actions";
import {isNullOrEmpty} from "./website-actions";
import {isNullOrUndefined} from "./website-actions";

export function log(txt) {
  /*eslint-disable-next-line*/
  console.log(txt);
}


export function isBot(ua) {
  if (ua.indexOf("GoogleBot") > 0) { return true; }
  if (ua.indexOf("BingBot") > 0) { return true; }
  if (ua.indexOf("Slurp") > 0) { return true; }
  if (ua.indexOf("DuckDuckBot") > 0) { return true; }
  if (ua.indexOf("Baiduspider") > 0) { return true; }
  if (ua.indexOf("YandexBot") > 0) { return true; }
  if (ua.indexOf("facebot") > 0) { return true; }
  if (ua.indexOf("ia_archiver") > 0) { return true; }
  return false;
}

export function needsProfiles(rtes, pth) {
  let isList = false;
  rtes.map((v, i) => {
    if (v.path === "") { v.path = "/"; }
    if (v.path == pth) {
      if (v.template.toLowerCase() === "profileslist") {
        isList = true;
      }
    }
  });
  return isList;
}


export function getServerCookie(cookies, key) {
  try {
    let tStr = cookies.filter((v) => { return v.key.toLowerCase() === key.toLowerCase(); })[0];
    return typeof tStr === "undefined" ? null : tStr.value;
  } catch (ex) {
  }
  return null;
}

export function checkCulture(dta,ref,ip) {
  let cp = wActs.culturePath(ref);
  let lanPath = "";
  let smtLan = dta.Settings.SmartDefaultLanguage;
  dta.Settings.Languages.map((v,i) => {
    if(v.Code === defaultLang(dta)) {
      v.Default = true;
      v.Selected = true;
      if(!smtLan) {
        lanPath =  v.Path;
      }
    } else {
      v.Default = false;
      v.Selected = false;
    }
    if(v.Path === null) {
      v.Path = "xx";
    }
    return null;
  });


  if (cp !== "/") {
    dta.Settings.SelectedLocal = cp;
    dta.Settings.SelectedLang = defaultLang(dta);
  } else {
    dta.Settings.SelectedLocal = smtLan ? "/" : lanPath;
    dta.Settings.SelectedLang = defaultLang(dta);
  }
  return dta;
}
export function loadWallet(cookies,dispatch) {
  let auth = getServerCookie(cookies,"auth");
  if(wActs.isNullOrEmpty(auth)) {
    return;
  }
  let headers = {
    'Authorization': "Bearer " + auth
  };

  let wallet = fetch(`${wConst.ROOT_URL()}/wallet/balance`, { headers: headers })
    .then(resp => resp.json())
    .then((data) => {
      if(!isNullOrUndefined(data.Code) && data.Code===200) {
        dispatch({type: wConst.USER_SET_WALLET, payload: data.Result});
      }
    }).catch((err) => {
      console.warn("Error calling api:", err);
    });
  addTask(wallet);
}

export function loadWebsiteSettingsServer(referer,ip,trans,pages,path, query, cookies, ua, ismob, cc, timers,anon, lists, packs) {
  return function (dispatch, getState) {
    dispatch({ type: wConst.RESET_STATE, payload: true });
    dispatch({ type: wConst.ACTION_FETCH_WEBSITESETTINGS_PENDING, payload: true });
    let ref = referer + query;

    let headers = {
      'X-Alt-Referer': ref,
      'X-Alt-IP': ip,
      'X-Alt-Country': cc,
    };

    //console.log(JSON.stringify(headers));

    let auth = getServerCookie(cookies,"auth");
    if(!wActs.isNullOrEmpty(auth)) {
      headers["Authorization"] = "Bearer " + auth;
    }
    if(!wActs.isNullOrEmpty(anon)) {
      headers["X-Alt-AnonymousId"] = anon;
    }
    headers['User-agent'] = ua;

    loadWallet(cookies,dispatch);

    let settings = fetch(`${wConst.ROOT_URL()}/context?include=page%2Csettings%2Chtmlsections%2Cmenu%2Cdevice`, { headers: headers })
      .then(resp => resp.json())
      .then((data) => {




        //Rewrites The Canoicals, Props, Etc..
        data.Result.Page = wActs.rewriteLinkHeaders(data.Result.Page, query, wActs.getCultByLang(data.Result,wActs.defaultLang(data.Result)));

        data.Result.Routes = pages; //These Are Pages To Route
        //Alot Of Site Stuff To Do When Loaded :) BEFORE We Fill The Dam Screen :P
        data.Result = checkCulture(data.Result, path, ip);
        data.Result.Lists = lists;
        data.Result.ServerParams = {
          Referer: referer, Ip: ip, Path: path, Query: query, Cookies: cookies, UserAgent: ua, IsMobile: ismob, Timers: timers
        };

        let tLoc = data.Result.Settings.SelectedLocal;

        if (tLoc === "/") {
          tLoc = getCultByLang(data.Result, defaultLang(data.Result)).Path;
        }
        let fLoc = tLoc;
        if (fLoc.toLowerCase() === "xx") {
          fLoc = "en";
        }

        wActs.markLanguageSelected(data.Result, fLoc);
        data.Result.Translations = trans;
        data.Result.Settings.LocalCSS = fLoc;
        if (fLoc === "gr") { fLoc = "el"; }
        if (fLoc === "rs") { fLoc = "sr"; }
        if (fLoc === "cz") { fLoc = "cs"; }

        data.Result.TranslationsLocal = fLoc;


        wActs.doTranlationReplaces(data.Result);
        wActs.saveSitePaths(data.Result);

        dispatch({ type: wConst.FETCH_POPPACKS_FULLFILLED, payload: { Code: 200, Message: "Success", Result: packs }});
        dispatch({ type: wConst.ACTION_FETCH_WEBSITESETTINGS_FULLFILLED, payload: data.Result });
        dispatch({ type: wConst.ACTION_FETCH_PAGE_FULLFILLED, payload: data.Result.Page });

        wActs.loadMoreData(dispatch,data.Result.Page,data.Result.Settings,ref,ip,anon,cc);

        if(!isNullOrEmpty(data.Result.Page.PriceList)) {
          dispatch({ type: wConst.FETCH_PRICELIST_FULLFILLED, payload: { Code: 200, Message: "", Result: data.Result.Page.PriceList } });
        }


        if(data.Result.Page.Name !== "404") {
          dispatch(wActs.SendPageVisit(referer,ip,anon,cc,ua));
        }


      }).catch((err) => {
        console.warn("Error calling api:", err);
      });
    addTask(settings);
  };
}
